import axios from 'axios'
import React, { useState } from 'react'
import { useTheme } from '../contexts/ThemeContext.tsx'
import { themes } from '../theme.ts'

const CampaignMenu = ({ campaign, setOpenMenuId, openMenuId, refreshCampaigns, onEdit, onDelete }: any) => {
    const { themeName } = useTheme();
    const rawData = localStorage.getItem('user');
    const cred = rawData ? JSON.parse(rawData) : null;
    const token = cred?.access;

    // console.log(campaign)
    const changeStatus = async (status: boolean) => {
        let is_live = status
        const data = new FormData()
        data.append('brand', campaign?.brand)
        data.append('is_live', is_live.toString())
        try {
            const response = await axios.patch(`${process.env.REACT_APP_DB_URI}/campaigns/${campaign?.id}/`, data, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            setOpenMenuId(false)
            if (typeof refreshCampaigns === "function") {
                refreshCampaigns(); // Fetch latest campaigns
            }
        } catch (err) {
            console.log(err)
        }
    }
    return (
        <>
            {openMenuId === campaign.id && (
                <div
                    className="absolute right-0 mt-2 w-40 rounded shadow-lg"
                    style={{
                        backgroundColor: themes[themeName].colors.surface,
                        color: themes[themeName].colors.text,
                        border: `1px solid ${themes[themeName].colors.border}`,
                        zIndex: 1200,
                    }}
                >
                    <button
                        className="block w-full text-left px-4 py-2"
                        onClick={() => changeStatus(true)}
                        style={{ background: 'transparent' }}
                    >
                        Active
                    </button>
                    <button
                        className="block w-full text-left px-4 py-2"
                        onClick={() => changeStatus(false)}
                        style={{ background: 'transparent' }}
                    >
                        Disable
                    </button>
                    <div className="border-t my-1" style={{ borderColor: themes[themeName].colors.border }}></div>
                    <button
                        className="block w-full text-left px-4 py-2 hover:bg-opacity-10 hover:bg-gray-500"
                        onClick={() => {
                            onEdit(campaign);
                            setOpenMenuId(null);
                        }}
                        style={{ background: 'transparent' }}
                    >
                        Edit
                    </button>
                    <button
                        className="block w-full text-left px-4 py-2 text-red-500 hover:bg-opacity-10 hover:bg-red-500"
                        onClick={() => {
                            onDelete(campaign);
                            setOpenMenuId(null);
                        }}
                        style={{ background: 'transparent', color: themes[themeName].colors.error }}
                    >
                        Delete
                    </button>
                </div>
            )}
        </>
    )
}

export default CampaignMenu
